import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import "./patreon-auth.scss";

import { Button, Input, Text } from "@ui-kit";
import {
  updatePatreonEmailTC,
  setServerErrorsAC,
  getServerError,
} from "@entities";
import { LoadingAdmin } from "@shared/ui";
import { useForm } from "@shared";
import onPatreonFormValid from "./patreon-validation.hook";
import PatreonIcon from "@ui-kit/icons/social/patreon-gray400.svg";

const PatreonAuth = ({ user = {}, className = '' }) => {
  const dispatch = useDispatch();
  const serverError = useSelector(getServerError);

  const [errors, setErrors] = useState({});
  const [isLoading, setIsLoading] = useState(false);

  const patreonEmail = user?.patreonEmail || "";
  const classes = ['patreon__form'];

  if (className) {
    classes.push(className);
  }

  const { formData, onChangeInput, onSubmitForm, setFormData } = useForm(
    { ...user, patreonEmail: patreonEmail },
    handlerBeforeSubmitingForm
  );

  useEffect(() => {
    setFormData(user);
    // eslint-disable-next-line
  }, [user]);

  useEffect(() => {
    return () => dispatch(setServerErrorsAC([]));
  }, [dispatch]);

  async function handlerBeforeSubmitingForm() {
    setIsLoading(true);

    const formErrors = onPatreonFormValid(formData);

    if (!user?.isActivated) {
      setIsLoading(false);
      return setErrors({
        ...formErrors,
        isActivated: "Your email is not activated",
      });
    }

    if (Object.keys(formErrors).length) {
      setIsLoading(false);
      return setErrors(formErrors);
    }

    dispatch(updatePatreonEmailTC(formData));
    setErrors({});
    setIsLoading(false);
  }

  return (
    <>
      {isLoading && <LoadingAdmin />}
      <form onSubmit={onSubmitForm} className={classes.join(' ')}>
        <Input
          placeholder="Enter your patreon email"
          name="patreonEmail"
          type="email"
          autoComplete="email"
          iconLeft={PatreonIcon}
          required
          label="Patreon email"
          value={formData?.patreonEmail || ""}
          onChange={onChangeInput}
          className={errors.patreonEmail && "form-item__error"}
        />
        {errors.patreonEmail && (
          <Text as="span" className="error">
            {errors.patreonEmail}
          </Text>
        )}

        <Button>Link patreon email</Button>
      </form>
      {!!serverError.length && (
        <div className="server__error">
          <Text as="span" className="error">
            {serverError}
          </Text>
        </div>
      )}
      {errors.isActivated && (
        <Text as="span" className="error">
          {errors.isActivated}
        </Text>
      )}
    </>
  );
};

export default PatreonAuth;
